import React from 'react';
import { User } from 'commons/models/marketingDashboard';

export interface HasPermissionArgument {
	entity?: string;
	configPageName: string;
	action?: string;
	appName?: any;
}
interface IUserContext {
	isLoggedIn: boolean;
	logoutUser: () => void;
	loginUser: (idToken: any, accessToken: any, profileObj: any, dashboardName: string) => any;
	loginOutsourceUser: (reqObj: { email: string; otp: number | undefined; userMerchant: string }, dashboardName: string) => any;
	user: User | null;
	roleConfig: any;
	permissionsConfig: any;
	checkIfLoggedIn: (dashboardName: string, userMerchant?: string) => any;
	getACLUsers: () => Promise<string[]>;
	aclUsers: string[];
}

const UserContext = React.createContext<IUserContext>({} as IUserContext);

export default UserContext;
